import Vue from 'vue';
import VueRouter from 'vue-router';

import ConfigView from '@/views/ConfigView/ConfigView.vue';
import PanelView from '@/views/PanelView/PanelView.vue';
import PanelOffline from '@/views/PanelView/PanelOffline/PanelOffline.vue';
import PanelVoicesList from '@/views/PanelView/PanelVoicesList/PanelVoicesList.vue';
import PanelVoiceSelected from '@/views/PanelView/PanelVoiceSelected/PanelVoiceSelected.vue';
import PanelSuccess from '@/views/PanelView/PanelSuccess/PanelSuccess.vue';
import PanelLoader from '@/views/PanelView/PanelLoader/PanelLoader.vue';
import PanelError from '@/views/PanelView/PanelError/PanelError.vue';

import TwitchService from '@/service/twitch/service';

Vue.use(VueRouter);

const routes = [
    {
        name: 'panel',
        path: '*/panel.html',
        component: PanelView,
        children: [
            {
                path: '/',
                name: 'VoicesList',
                component: PanelVoicesList,
                beforeEnter(to, from, next) {
                    TwitchService.setConfigurationPanelView();
                    TwitchService.listenConfiguration();
                    TwitchService.viewerOnChanged();

                    next();
                },
            },
            {
                path: 'offline',
                name: 'Offline',
                component: PanelOffline,
            },
            {
                path: ':id/:time/:price',
                name: 'PanelLoader',
                component: PanelLoader,
            },
            {
                path: 'success',
                name: 'PanelSuccess',
                component: PanelSuccess,
            },
            {
                path: ':id/:time/:price/:responseStatus',
                name: 'PanelError',
                component: PanelError,
            },
            {
                path: ':id',
                name: 'VoiceSelected',
                component: PanelVoiceSelected,
            },
        ],
    },
    {
        name: 'config',
        path: '*/index.html',
        component: ConfigView,
    },
];

export const router =  new VueRouter({
    mode: 'history',
    routes,
});
